import axios from 'axios';

// PUT /admin/token/:tokenId/reassign { candidateId } — moves an UNSTARTED token (status 1) to
// another candidate of the SAME sponsor with no active assignment. The backend authoritatively
// enforces status/same-sponsor/no-active-assignment; any violation returns a 409 surfaced here.
export async function reassignToken(tokenId, candidateId) {
  try {
    const res = await axios.put(`/admin/token/${tokenId}/reassign`, { candidateId });
    return { ok: res.data && res.data.status === 'SUCCESS' };
  } catch (error) {
    const data = error.response && error.response.data;
    return { ok: false, message: (data && data.status_message) || 'Failed to reassign token.' };
  }
}
